/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable linebreak-style */
import React from 'react'
import {
  Button
} from 'components/atoms'
import PropTypes from 'prop-types'
import { Toast } from 'containers'
import { useEditorContext, actions } from 'context/EditorContext';
import { produce } from 'immer'
import { useDispatch } from 'react-redux'
import { saveDraft } from 'redux/draftsSlice'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify';

const EditorPasteModule = () => {
  const { pageId, lang } = useParams()

  const [{ pageLiveData }, dispatch] = useEditorContext();
  const dispatchRedux = useDispatch()
  const module2paste = JSON.parse(window.sessionStorage.getItem('module2paste'));

  const handlePasteContent = () => {
    const pageWithModule = produce(pageLiveData, draftState => {
      // eslint-disable-next-line no-param-reassign
      draftState.push(module2paste)
    })
    dispatch({
      type: actions.PAGE_DATA_UPDATE,
      data: pageWithModule,
    });
    dispatchRedux(saveDraft({ pageId, content: pageWithModule, lang }))
    window.sessionStorage.setItem('module2paste', null);
    toast.success(
      <Toast
        type="success"
        title="Adicionado"
        description="Edite o módulo antes de gravar"
      />
    );
  }

  return (
    <>
      {module2paste !== null && (
        <Button modifiers={['dark']} onClick={handlePasteContent}>
              Colar módulo
        </Button>
      )}
    </>
  )
}


EditorPasteModule.propTypes = {

}

EditorPasteModule.defaultProps = {

}

export default EditorPasteModule
